import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeMetod, getCard } from '../../actions'

const Tarjetas = () => {

  const tarjetas=[ 
    {
      titular: 'Martina Fernandez Vargas'
    },
    {
      titular: 'Tomás Arzeno'
    },
    {
      titular: 'RODOLFO ORLANDO FERNANDEZ'
    },
  ]
 
  const [input,setInput] = useState({
    titular:''
  })

  const dispatch = useDispatch()

  const handleChange = (event: any) => {
    const tarjeta = tarjetas.find((t) => t.titular === event.target.value);
    if (tarjeta) {
      setInput({
        titular: tarjeta.titular,
      });
      dispatch(changeMetod(tarjeta)).then(() => {
        dispatch(getCard());
      });
    }
  };
    
  useEffect(() => {
    dispatch(changeMetod(input)).then(() => {
      dispatch(getCard());
    });
  }, [input]);

  
  const card = useSelector((state : any) => state.tarjeta)


  return (
    <div className='flex flex-col w-full p-8 items-center font-roboto'>
      <select name="banco" className='border rounded p-2 text-xs' value={input.titular} onChange={(event) => handleChange(event)}>
        <option value="">Seleccione una opción</option>
        {
          tarjetas.map((option, ind) => {
            return (
              <option key={ind} value={option.titular} className='bg-background_home text-white'>{option.titular}</option>
            )
          })
        }
      </select>
    
 <div>
    <h1>TARJETA ACTIVA</h1>
      <table className="table-fixed mt-8 text-[10px] sm:text-[20px]">

          <thead className="bg-background_home text-white">
            <tr>
              <th className="w-1/4  border-2  py-2">Titular</th>
              <th className="w-1/4  border-2  py-2">Cbu/Cvu</th>
              <th className="w-1/4   border-2  py-2">Cuil/Cuit</th>
              <th className="w-1/4  border-2  py-2">Banco</th>
            </tr>
          </thead>

           <tbody className="text-center font-roboto bg-white border">
            <tr className="border-b">
             <td className="py-2 border-2 ">{card.card &&  card.card.titular}</td>
             <td className="py-2  border-2 ">{card.card && card.card.cvu}</td>
             <td className="py-2 border-2  ">{card.card && card.card.cuit}</td>
             <td className="py-2  border-2 ">{card.card && card.card.banco}</td>
            </tr>
           </tbody> 
      </table>
 </div>
    </div>
  )
}

export default Tarjetas